import { createAction, ActionFunction1, Action } from "redux-actions";
import { INIT_CONSTANTS } from "main/javascripts/constants/actionType/ConstantActionType";

export const initConstants: ActionFunction1<any, Action<any>> = createAction<
  any,
  any
>(INIT_CONSTANTS, (param: any): any => {
  return {
    facebookAppId: param.facebookAppId,
  };
});
